/* tslint:disable */
/* eslint-disable */
/**
 * DevourPlay OpenAPI (Swagger) Documentation
 * This is the API documentation generated from the swagger comments in the backend. These correspond directly to the client library.
 *
 * The version of the OpenAPI document: N/A
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface PhoneNumber
 */
export interface PhoneNumber {
    /**
     * 
     * @type {string}
     * @memberof PhoneNumber
     */
    normalized: string;
    /**
     * 
     * @type {string}
     * @memberof PhoneNumber
     */
    countryCode: string;
    /**
     * 
     * @type {string}
     * @memberof PhoneNumber
     */
    nationalNumber: string;
}

/**
 * Check if a given object implements the PhoneNumber interface.
 */
export function instanceOfPhoneNumber(value: object): value is PhoneNumber {
    if (!('normalized' in value) || value['normalized'] === undefined) return false;
    if (!('countryCode' in value) || value['countryCode'] === undefined) return false;
    if (!('nationalNumber' in value) || value['nationalNumber'] === undefined) return false;
    return true;
}

export function PhoneNumberFromJSON(json: any): PhoneNumber {
    return PhoneNumberFromJSONTyped(json, false);
}

export function PhoneNumberFromJSONTyped(json: any, ignoreDiscriminator: boolean): PhoneNumber {
    if (json == null) {
        return json;
    }
    return {
        
        'normalized': json['normalized'],
        'countryCode': json['countryCode'],
        'nationalNumber': json['nationalNumber'],
    };
}

export function PhoneNumberToJSON(json: any): PhoneNumber {
    return PhoneNumberToJSONTyped(json, false);
}

export function PhoneNumberToJSONTyped(value?: PhoneNumber | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'normalized': value['normalized'],
        'countryCode': value['countryCode'],
        'nationalNumber': value['nationalNumber'],
    };
}

